import { Component, OnInit, Input } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ReportsCommonService } from 'app/modules/reports/services/reports-common.service';
import { MatDialog } from '@angular/material/dialog';
import { PopupViewComponent } from '../../popup-view/popup-view.component';
import { EstudioReports } from 'app/modules/reports/entities/estudio-model';
import { EmpresaTreeViewService } from 'app/modules/employee/services/empresa-treeView.service';

@Component({
    selector: 'app-estudio-reports',
    templateUrl: './estudio-reports.component.html',
    styleUrls: ['./estudio-reports.component.scss'],
    standalone: false
})
export class EstudioReportsComponent implements OnInit {
    @Input() public sectionName: string;
    public canDelete = false;
    public estudioReport: EstudioReports;
    public reportList$: any[];

    constructor(
        public reportsCommonService: ReportsCommonService,
        public dialog: MatDialog,
        private _empresaTreeViewService: EmpresaTreeViewService
    ) {
        this._empresaTreeViewService.EmpId.subscribe((_res: any) => {
            if (_res > 0) {
                this.resetReportSelection(_res);
            }
        });
    }

    ngOnInit(): void {
        this.intiReportList();
    }

    intiReportList(): void {
        this.reportList$ = [
            {
                column: [
                    {
                        text: 'Portada',
                        value: 1,
                        visible: true,
                        checked: this.estudioReport.Portada,
                    },
                    {
                        text: 'Cuadro de mando',
                        value: 2,
                        visible: true,
                        checked: this.estudioReport.CuadroDeMando,
                    },
                    {
                        text: 'Abs. mensual',
                        value: 3,
                        visible: true,
                        checked: this.estudioReport.AbsMensual,
                    },
                    {
                        text: 'Abs. acumulado',
                        value: 4,
                        visible: true,
                        checked: this.estudioReport.AbsAcumulado,
                    },
                    {
                        text: 'Bajas activas',
                        value: 6,
                        visible: true,
                        checked: this.estudioReport.BajasActivas,
                    },
                    {
                        text: 'Bajas comunicadas',
                        value: 7,
                        visible: true,
                        checked: this.estudioReport.BajasComunicadas,
                    },
                ],
            },
            {
                column: [
                    {
                        text: 'Gaps de baja',
                        value: 8,
                        visible: true,
                        checked: this.estudioReport.GapsDeBaja,
                    },
                    {
                        text: 'Duración media',
                        value: 9,
                        visible: true,
                        checked: this.estudioReport.DuracionMedia,
                    },
                    {
                        text: 'Diagnóstico',
                        value: 10,
                        visible: true,
                        checked: this.estudioReport.Diagnostico,
                    },
                    {
                        text: 'Edades',
                        value: 11,
                        visible: true,
                        checked: this.estudioReport.Edades,
                    },
                    {
                        text: 'Diagn. edad',
                        value: 12,
                        visible: true,
                        checked: this.estudioReport.DiagnEdad,
                    },
                    {
                        text: 'Género',
                        value: 13,
                        visible: true,
                        checked: this.estudioReport.Genero,
                    },
                ],
            },
            {
                column: [
                    {
                        text: 'Diagn. género',
                        value: 14,
                        visible: true,
                        checked: this.estudioReport.DiagnGenero,
                    },
                    {
                        text: 'Diagn. edad/género',
                        value: 15,
                        visible: true,
                        checked: this.estudioReport.DiagnEdadGenero,
                    },
                    {
                        text: 'Días de la semana',
                        value: 16,
                        visible: true,
                        checked: this.estudioReport.DiasDeLaSemana,
                    },
                ],
            },
        ];
    }

    setSelectedReport(report: any, element: MatCheckboxChange): void {
        if (this.estudioReport !== null) {
            switch (report.text) {
                case 'Portada':
                    this.estudioReport.Portada = element.checked;
                    break;

                case 'Cuadro de mando':
                    this.estudioReport.CuadroDeMando = element.checked;
                    break;

                case 'Abs. mensual':
                    this.estudioReport.AbsMensual = element.checked;
                    break;

                case 'Abs. acumulado':
                    this.estudioReport.AbsAcumulado = element.checked;
                    break;

                case 'Bajas activas':
                    this.estudioReport.BajasActivas = element.checked;
                    break;

                case 'Bajas comunicadas':
                    this.estudioReport.BajasComunicadas = element.checked;
                    break;

                case 'Gaps de baja':
                    this.estudioReport.GapsDeBaja = element.checked;
                    break;

                case 'Duración media':
                    this.estudioReport.DuracionMedia = element.checked;
                    break;

                case 'Diagnóstico':
                    this.estudioReport.Diagnostico = element.checked;
                    break;

                case 'Edades':
                    this.estudioReport.Edades = element.checked;
                    break;

                case 'Diagn. edad':
                    this.estudioReport.DiagnEdad = element.checked;
                    break;

                case 'Género':
                    this.estudioReport.Genero = element.checked;
                    break;

                case 'Diagn. género':
                    this.estudioReport.DiagnGenero = element.checked;
                    break;

                case 'Diagn. edad/género':
                    this.estudioReport.DiagnEdadGenero = element.checked;
                    break;

                case 'Días de la semana':
                    this.estudioReport.DiasDeLaSemana = element.checked;
                    break;

                default:
                    break;
            }
        }
    }

    openAttributesPopup(): void {
        this.dialog.open(PopupViewComponent, {
            width: '400px',
        });
    }

    removeReportSection(component: any): void {
        this.reportsCommonService.removeEstudioReportElement(component);
    }

    //Reset the left-hand side report selections on company change
    public resetReportSelection(result: any) {
        //NOTE: Keep only the 'Empresa' component and remove all other attribute-based components
        if (this.sectionName == 'Empresa') {
            this.estudioReport.AbsAcumulado = false;
            this.estudioReport.AbsMensual = false;
            this.estudioReport.BajasActivas = false;
            this.estudioReport.BajasComunicadas = false;
            this.estudioReport.CuadroDeMando = false;
            this.estudioReport.DiagnEdad = false;
            this.estudioReport.DiagnEdadGenero = false;
            this.estudioReport.Diagnostico = false;
            this.estudioReport.DiagnGenero = false;
            this.estudioReport.DiasDeLaSemana = false;
            this.estudioReport.DuracionMedia = false;
            this.estudioReport.Edades = false;
            this.estudioReport.GapsDeBaja = false;
            this.estudioReport.Genero = false;
            this.estudioReport.Portada = false;
            this.intiReportList();
            this.estudioReport.CompanyId = parseInt(result); //Update the company Id with latest selected value
        } else {
            this.removeReportSection(this);
            this.reportsCommonService.refreshEstudioReportElements();
        }
    }
}
